import {Period} from "../models/Periods";
import http from "./httpRequest";

class PeriodsService {
	async getPeriods() {
		let response = await http.get<Period[]>('/periods');
		return response.data;
	}

	async createPeriod(id: string, eventDate: string) {
		const resp = await http.post<Period>('/periods', {period: id, event_date: eventDate});
		return resp?.data;
	}

	async getCurrentPeriod() {
		let response = await http.get<Period>('/periods/currentPeriod');
		return response.data;
	}

	async getPeriodSuggestion() {
		const regex = /^(\d{4})-([12])$/;
		const res = await http.get<Period>('/periods/latestPeriod');
		const period = res?.data?.id;
		const match = period.match(regex);

		if (match) {
			let year = parseInt(match[1]);
			let slug = parseInt(match[2]);

			if (slug === 1) {
				return `${year}-${slug+1}`;
			}
			if (slug === 2) {
				return `${year+1}-${1}`;
			}
		}
		return null;
	}
	
	async updatePeriod(id: string, isActive: boolean) {
		return await http.put<Period>(`/periods/${id}`, { is_active: isActive });
	}
}

export default new PeriodsService();